module.exports = __webpack_public_path__ + "static/media/new-insight.a3525f29.svg";